/* eslint-disable no-restricted-imports */
import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import ControlsDiagonalsOutsight from '@/external/icons/ControlsDiagonalsOutsight';

const FullscreenToggle: FC = () => {
  const { setFullScreen } = useGameContext();
  return (
    <div
      className="cursor-pointer"
      data-testid="fullscreen-toggle"
      onClick={() => setFullScreen(true)}
    >
      <ControlsDiagonalsOutsight className="text-moon-32 text-trunks" />
    </div>
  );
};

export default FullscreenToggle;
